import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../hooks/useAuth";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import MDInput from "../../../components/MDInput";
import MDButton from "../../../components/MDButton";

// Authentication layout components
import BasicLayout from "../components/BasicLayout";

// Images
import bgImage from "../../../assets/images/bg-sign-in-basic.webp";
import MDSnackbar from "../../../components/MDSnackbar";

function Basic() {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const [user, setUser] = useState({
    username: "",
    password: "",
  });

  const [notification, setNotification] = useState({
    open: false,
    color: "info",
    title: "",
    content: "",
  });

  const closeNotification = () => setNotification({ ...notification, open: false });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setUser((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");

    if (!user.username || !user.password) {
      setNotification({
        open: true,
        color: "error",
        title: "Error",
        content: "Por favor, rellena todos los campos",
      });
      setLoading(false);
      return;
    }

    try {
      await login(user.username, user.password);
      navigate("/dashboard");
    } catch (err) {
      console.error(err);
      setNotification({
        open: true,
        color: "error",
        title: "Error",
        content: "Credenciales inválidas o error en el servidor",
      });
      setLoading(false);
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Revista Guineo
          </MDTypography>
          <MDTypography variant="button" color="white" mt={1}>
            Ingresa tus credenciales
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit}>
            <MDBox mb={2}>
              <MDInput
                type="text" // Changed to email as per authService mock (admin@guineo.com)
                label="Usuario"
                name="username"
                value={user.username}
                onChange={handleChange}
                fullWidth
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Contraseña"
                name="password"
                value={user.password}
                onChange={handleChange}
                fullWidth
              />
            </MDBox>
            {error && (
              <MDBox textAlign="center" mb={2}>
                <MDTypography
                  variant="caption"
                  color="error"
                  fontWeight="medium"
                >
                  {error}
                </MDTypography>
              </MDBox>
            )}
            <MDBox mt={4} mb={1}>
              <MDButton type="submit" variant="gradient" color="info" fullWidth disabled={loading}>
                {loading ? "Cargando..." : "Iniciar sesión"}
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
      <MDSnackbar
        color={notification.color}
        icon={notification.color === "error" ? "warning" : "check"}
        title={notification.title}
        content={notification.content}
        dateTime="Ahora"
        open={notification.open}
        onClose={closeNotification}
        close={closeNotification}
        bgWhite
      />
    </BasicLayout>
  );
}

export default Basic;
